import { AttributeDefRow, attributeDefRowSchemaView, ProfileAttribute, profileAttributeSchema } from "@bonusmap/api-types";
import { ProfileBaseComponent } from "./profile-base-component";
import { isNumber } from "@bonusmap/shared_ui/library";
import { IProfileAttributes } from "./IProfileAttributes";
import { createChoicesInstance } from "../../utils/createChoicesInstance";
const { Choices } = window;
export class ProfileAttributeItem extends ProfileBaseComponent {
    static webComponentName: string = "profile-attribute-item";
    static observedAttributes = ['data-attribute'];
    protected _templateId: string = "profile-attribute-item";
    // campo selezione attributi
    private attributeItemSelect!: HTMLSelectElement;
    private clearButton!: HTMLElement;
    private choicesInstance!: InstanceType<Window['Choices']>;
    private _componentId!: string;
    public get componentId(): string {
        if (!this._componentId) {
            this._componentId = `${this.createRandomId()}`;
        }
        return this._componentId;
    }
    // id dell'attributo 
    private _value!: number | null;
    public get value(): number | null {
        return this._value;
    }
    public set value(value: number | string) {
        if (isNumber(value)) {
            this._value = value as number;
        }
        else {
            this._value = null;
        }
    }
    private _personalAttribute!: AttributeDefRow;
    public get personalAttribute(): AttributeDefRow {
        return this._personalAttribute;
    }

    public set personalAttribute(value: AttributeDefRow) {
        this.dispatch('attribute-changed', {
            attribute: value
        });

        this._personalAttribute = value;
    }
   
    public get parentProfileAttributes(): IProfileAttributes | null {
        return this.closest('profile-attributes');
    }
    private async performSearch(searchTerm: string): Promise<void> {
        if (!searchTerm || searchTerm.length == 0) {
            this.choicesInstance.clearChoices();
        }
        try {
            let whereClause = searchTerm && searchTerm.length > 0
                ? `name ILIKE $1`
                : `1=1`; // Cerca tutti gli elementi se non c'è termine di ricerca
            let params = searchTerm && searchTerm.length > 0
                ? [`%${searchTerm}%`]
                : [];
            if (this.parentProfileAttributes) {
                const excludeIds = this.parentProfileAttributes.ids; 
                if (excludeIds.length > 0) {
                    const placeholders = excludeIds.map((id) => `${id}`).join(', ');
                    whereClause += ` AND id NOT IN (${placeholders})`;
                }
            }
            const result = await window.api.manager.personalAttributes.query(whereClause, params, 'name', 20);
            if (result.success && result.data && result.data.length > 0) {
                const choicesData = result.data.map(item => ({
                    value: item.id.toString() || "",
                    label: item.name || "",
                    customProperties: {
                        row: item
                    }
                }));

                this.choicesInstance.setChoices(choicesData as any, 'value', 'label', true);
            } else {
                this.choicesInstance.clearChoices();
            }
        } catch (error) {
            console.error(`Error searching data:`, error);
            this.choicesInstance.clearChoices();
        }
    }
   
    protected onAttributeChange(name: string, oldValue: string, newValue: string): void {
        if (name === 'data-attribute') {
            // Gestisci il cambiamento dell'attributo se necessario
            const dataAttribute = this.dataset.attribute;
            if (dataAttribute) {
                const parsed = attributeDefRowSchemaView.safeParse(JSON.parse(dataAttribute));
                if (parsed.success) {
                    this.personalAttribute = parsed.data;
                    this.value = parsed.data.id;
                    this.render();
                } else {
                    this.personalAttribute = null;
                    console.warn("Dati attributo non validi:", parsed.error);
                }
            }
        }
    }
    private syncSelectionFromChoices(source = ''): void {
        const selectedValue = this.choicesInstance.getValue(true);
        this.value = selectedValue as string;


        const choice = this.choicesInstance.getValue(false);
        console.log(`${source} : `, choice);
        if (choice && (choice as any).customProperties?.row) {
            this.personalAttribute = (choice as any).customProperties.row;
            this.value = this.personalAttribute.id;
            if(this.isAttributeValid(this.personalAttribute)) {
                this.render();
            }
        }
        else {
            this.personalAttribute = null;
            this.value = 0;
        }

        //     if (choice.customProperties?.territorialData) {
        //         newSelection.push(choice.customProperties.territorialData);
        //     }
        // this._currentSelection = newSelection;
    }
    private initializeChoices(): void {
        // istanzia di Choices.js per la selezione degli attributi
        this.choicesInstance = createChoicesInstance(this.attributeItemSelect, {
            removeItemButton: true,
            searchEnabled: true,
            addItems: false,
            duplicateItemsAllowed: false,
            placeholder: true,
            
        })
        this.attributeItemSelect.addEventListener('search', (event: any) => {
            const searchTerm = event.detail.value;
            this.performSearch(searchTerm);
        });
        this.attributeItemSelect.addEventListener('showDropdown', (event: any) => {
            // Carica i dati iniziali al focus se il dropdown è vuoto
            const currentSearchTerm = this.choicesInstance.input?.value || '';
            this.performSearch(currentSearchTerm);
        });
        this.attributeItemSelect.addEventListener('change', (event: any) => {
            this.syncSelectionFromChoices("change");
        });
        this.attributeItemSelect.addEventListener('removeItem', (event: any) => {
            // this.syncSelectionFromChoices("removeItem");
        });
    }
    protected buildRenderingData(): Record<string, any> {
        return {
            componentId: this.componentId,
            value: this.value,
            parentMatchAttributes: this.parentProfileAttributes,
            personalAttribute: this.personalAttribute,
            readOnly: this.readOnly
        };
    }
    protected reset (): void {
        this.choicesInstance?.clearStore();
        this.personalAttribute = null;
        this.value = null;
        this.render();
        this.dispatch('attribute-changed', {
            attribute: null
        });
    }   
    protected afterRender(): void {
        this.attributeItemSelect = this.roleElementSelector("attribute-item-select") as HTMLSelectElement;
        if (this.attributeItemSelect) {
            this.initializeChoices();
        }
        else {
        }
        this.clearButton = this.roleElementSelector("attribute-item-remove") as HTMLElement;
        this.clearButton?.addEventListener('click', (event) => {
            event.preventDefault();
            this.reset();
        });
    }


}